import { PERMISSION } from "Constants";
import { useLoginInfo } from "Hooks";
import { useGetWhoamiQuery } from "Services";

const useShowAddMemberColumn = (): boolean => {
  const { isSSOLogin } = useLoginInfo();
  const { data: whoami } = useGetWhoamiQuery();

  if (isSSOLogin || !whoami) return false;

  const { org, groups } = whoami.permissions;
  return [org, ...Object.values(groups)].some((permissions) =>
    permissions.includes(PERMISSION.ADD_ORGANIZATION_MEMBERS_TO_GROUP),
  );
};

export default useShowAddMemberColumn;
